import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { BlogService } from "src/app/api/blog.service";
import { BlogPost, BlogPostType } from "src/app/models/blog";
import { Theme } from "src/app/models/theme";
import { AmplitudeAnalyticsService } from "src/app/services/amplitude-analytics.service";
import { MobileWebViewService } from "src/app/services/mobile-web-view.service";
import { ThemeService } from "src/app/services/theme.service";

@Component({
    selector: "app-page",
    templateUrl: "./page.component.html",
    styleUrls: ["./page.component.scss"],
    standalone: false
})
export class PageComponent implements OnInit, OnDestroy {
  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;

  private destroy$ = new Subject<void>();

  loading = false;
  data: BlogPost;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blogService: BlogService,
    private themeService: ThemeService,
    private mobileWebViewService: MobileWebViewService,
    private amplitudeAnalytics: AmplitudeAnalyticsService
  ) {}

  ngOnInit() {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      const key = params.get("key");
      if (key) {
        this.getData(key);
      }
    });

    const theme = this.route.snapshot.queryParamMap.get("theme");
    this.setTheme((theme as Theme) || Theme.Light);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.themeService.reset();
  }

  private setTheme(theme: string): void {
    switch (theme.toUpperCase()) {
      case "DARK":
        this.themeService.set(Theme.Dark);
        break;
      case "LIGHT":
        this.themeService.set(Theme.Light);
        break;
      default:
        console.warn(`Unsupported theme: ${theme}`);
    }
  }

  getData(key: string) {
    this.loading = true;
    this.data = null;

    this.blogService
      .getOne({
        type: BlogPostType.Page,
        slug: key,
        slugLocale: true,
      })
      .subscribe(
        (response) => {
          this.loading = false;
          this.data = response;
          this.amplitudeAnalytics.sendPage(this.router.url, {});
        },
        (err) => {
          this.loading = false;
          this.router.navigate(["404"]);
        }
      );
  }
}
